import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import axiosInstance from "../apis/axios.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoggedIn: false,
    categories: [],
    products: [],
    pagination: {},
    userFavorites: [],
    viewedProduct: {},
    viewedQrCode: {},
    searchQuery:''
  },
  mutations: {
    SET_PRODUCTS(state, payload) {
      state.products = payload.products;
    },
    SET_SEARCH_QUERY(state, payload) {
      state.searchQuery = payload;
    },
    SET_CATEGORIES(state, payload) {
      state.categories = payload.categories;
    },
    SET_PAGINATION(state, payload) {
      state.pagination = {
        totalItems: payload.totalItems,
        totalPages: payload.totalPages,
        currentPage: payload.currentPage,
      };
    },
    SET_FAVORITES(state, payload) {
      state.userFavorites = payload;
    },
    SET_VIEWED_PRODUCT(state, payload) {
      state.viewedProduct = payload;
    },
    SET_VIEWED_QRCODE(state, payload) {
      state.viewedQrCode = payload;
    },
    SET_LOGIN_STATUS(state, payload) {
      state.isLoggedIn = payload.status;
    },
  },
  actions: {
    async postRegister(context, payload) {
      return axiosInstance({
        method: "post",
        url: "/customer/register",
        data: payload,
      });
    },
    async postLogin(context, payload) {
      return axiosInstance({
        method: "post",
        url: "/customer/login",
        data: payload,
      });
    },
    async googleSignIn(context, payload) {
      return axiosInstance({
        method: "post",
        url: "/customer/googleSignIn",
        data: {google_token: payload},
      });
    },
    async checkToken() {
      return axiosInstance({
        method: "get",
        url: "/checkToken",
        headers: { access_token: localStorage.access_token },
      });
    },
    fetchProducts(context) {
      axiosInstance({
        method: "get",
        url: `/customer/products/`+location.search,
      })
        .then(({ data }) => {
          context.commit("SET_PRODUCTS", data);
          context.commit("SET_PAGINATION", data);
        })
        .catch((err) => {
          context.commit("SET_PRODUCTS", [])
          console.log(err.response);
        });
    },
    async fetchSingleProduct(context, payload) {
      return axiosInstance({
        method: "get",
        url: `/customer/products/${payload.id}`,
      })
    },
    fetchCategories(context) {
      axiosInstance({
        method: "get",
        url: "/categories",
      })
        .then(({ data }) => {
          context.commit("SET_CATEGORIES", data);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    fetchFavorites(context) {
      axiosInstance({
        method: "get",
        url: "/customer/favorites",
        headers: { access_token: localStorage.access_token },
      })
        .then(({ data }) => {
          context.commit("SET_FAVORITES", data);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    async addToFavorites(context,payload){
      return axiosInstance({
        method: 'post',
        url:`/customer/favorites/${payload}`,
        headers: { access_token: localStorage.access_token },
      })
    },
    async removeFavorites(context,payload){
      return axiosInstance({
        method: 'delete',
        url:`/customer/favorites/${payload}`,
        headers: { access_token: localStorage.access_token },
      })
    },
    
    getQrCode(context, payload) {
      let url = "https://api.happi.dev/v1/qrcode";

      let sourceUrl = document.location.host+payload.data;
      axios({
        method: "get",
        url: url,
        params:{
          apikey: "525376HolXFreBKKfwfYKvCYqidNJ7y9Gyr5P2Yjm3JAC7mj0QgmQISV",
          data: sourceUrl,
        }
      })
        .then(({data}) => {
          context.commit("SET_VIEWED_QRCODE", data.qrcode);
        })
        .catch((err) => {
          console.log(err);
        });
    },

  },
  modules: {},
});
